import { api } from '@/shared/api/axios';
import type { DealScore } from '@/features/deals/types';
import type {
  AnomalyRow, BriefingInsight, CallOptimizerResponse, LeadScore,
  NicheRow, ScrapeAdvisorResponse,
} from '../types';
import { withAiApiError } from './errors';
import { aiApiPaths } from './paths';

export interface LeadScoreResponse { scores: LeadScore[] }
export interface DealScoresResponse { deals: DealScore[] }

export const aiInsightsApi = {
  briefing: () => withAiApiError(async () =>
    (await api.get<{ insights: BriefingInsight[] }>(aiApiPaths.briefing)).data),
  leadScore: (leadId: string) => withAiApiError(async () =>
    (await api.get<{ id: string; score: number }>(aiApiPaths.leadScore(leadId))).data),
  leadScores: () => withAiApiError(async () =>
    (await api.get<LeadScoreResponse>(aiApiPaths.leadScores)).data),
  dealScores: () => withAiApiError(async () =>
    (await api.get<DealScoresResponse>(aiApiPaths.dealScores)).data),
  callOptimizer: () => withAiApiError(async () =>
    (await api.get<CallOptimizerResponse>(aiApiPaths.callOptimizer)).data),
  nicheIntelligence: () => withAiApiError(async () =>
    (await api.get<{ niches: NicheRow[] }>(aiApiPaths.nicheIntelligence)).data),
  anomalies: () => withAiApiError(async () =>
    (await api.get<{ anomalies: AnomalyRow[] }>(aiApiPaths.anomalies)).data),
  scrapeAdvisor: () => withAiApiError(async () =>
    (await api.get<ScrapeAdvisorResponse>(aiApiPaths.scrapeAdvisor)).data),
};
